import { useState, useEffect, useCallback } from "react";

const clamp = (value: number) => Math.max(0, value);

const isBetween = (value: number, floor: number, ceil: number) =>
  value >= floor && value <= ceil;

const useScrollspy = (ids: string[], offset: number = 0) => {
  const [activeIndex, setActiveIndex] = useState<undefined | number>(undefined);

  const listener = useCallback(() => {
    const scroll = window.scrollY;
    const position = ids
      .map((id) => {
        const element = document.getElementById(id);
        if (!element) return { id, top: -1, bottom: -1 };
        const rect = element.getBoundingClientRect();
        const top = clamp(rect.top + scroll - offset);
        const bottom = clamp(rect.bottom + scroll - offset);
        return { id, top, bottom };
      })
      .findIndex(({ top, bottom }) => isBetween(scroll, top, bottom));
    if (position !== -1) setActiveIndex(position);
  }, [ids, offset]);

  useEffect(() => {
    window.addEventListener("resize", listener);
    window.addEventListener("scroll", listener);

    return () => {
      window.removeEventListener("resize", listener);
      window.removeEventListener("scroll", listener);
    };
  }, [listener]);

  return activeIndex;
};

export default useScrollspy;
